import { apiRequest } from "./apiClient";

type SuccessListResponse = {
  readonly success?: boolean;
  readonly data: string[];
};

type SuccessCountyResponse = {
  readonly success?: boolean;
  readonly data: { readonly county: string | null };
};

export const fetchLocationStates = async (): Promise<string[]> => {
  const response = await apiRequest("/location-reference/states");
  const json = (await response.json()) as SuccessListResponse;
  return Array.isArray(json.data) ? json.data : [];
};

export const fetchLocationCities = async (state: string): Promise<string[]> => {
  const sp = new URLSearchParams({ state });
  const response = await apiRequest(`/location-reference/cities?${sp.toString()}`);
  const json = (await response.json()) as SuccessListResponse;
  return Array.isArray(json.data) ? json.data : [];
};

export const fetchLocationZips = async (state: string, city: string): Promise<string[]> => {
  const sp = new URLSearchParams({ state, city });
  const response = await apiRequest(`/location-reference/zips?${sp.toString()}`);
  const json = (await response.json()) as SuccessListResponse;
  return Array.isArray(json.data) ? json.data : [];
};

export const fetchLocationCounty = async (
  state: string,
  city: string,
  zip: string
): Promise<string | null> => {
  const sp = new URLSearchParams({ state, city, zip });
  const response = await apiRequest(`/location-reference/county?${sp.toString()}`);
  const json = (await response.json()) as SuccessCountyResponse;
  const county = json.data?.county;
  return county != null && county.trim() !== "" ? county.trim() : null;
};
